// @ts-nocheck
/* eslint-disable no-extend-native, no-loop-func */
export {};
/**
 * src/polyfills.ts
 *
 * Manual polyfills (no core-js)
 * Target: iOS >= 12, Safari >= 12.1, Chrome >= 80, Edge >= 79, Samsung >= 12, Android >= 6
 */

// ---------- OBJECT ----------
if (!(Object as any).hasOwn) {
    (Object as any).hasOwn = function (obj: unknown, prop: PropertyKey) {
        return Object.prototype.hasOwnProperty.call(obj as object, prop);
    };
}

if (!Object.assign) {
    Object.assign = function (target: any, ...sources: any[]) {
        if (target == null) throw new TypeError('Cannot convert undefined or null to object');
        const to = Object(target);
        for (const source of sources) {
            if (source != null) {
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        to[key] = source[key];
                    }
                }
            }
        }
        return to;
    };
}

if (!Object.fromEntries) {
    Object.fromEntries = function (entries: any) {
        const obj: any = {};
        for (const [key, value] of entries) obj[key] = value;
        return obj;
    };
}

if (!Object.entries) {
    Object.entries = function (obj: any) {
        const ownProps = Object.keys(obj);
        let i = ownProps.length;
        const resArray = new Array(i);
        while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];
        return resArray;
    };
}

if (!Object.values) {
    Object.values = function (obj: any) {
        return Object.keys(obj).map(k => obj[k]);
    };
}

// ---------- ARRAY ----------
if (!Array.prototype.flat) {
    Array.prototype.flat = function (depth: number = 1): any[] {
        return this.reduce((acc: any[], val: any) =>
            acc.concat(Array.isArray(val) && depth > 1 ? val.flat(depth - 1) : val), []);
    };
}

if (!Array.prototype.flatMap) {
    Array.prototype.flatMap = function (callback: any, thisArg?: any) {
        return this.map(callback, thisArg).flat();
    };
}

if (!Array.prototype.at) {
    Array.prototype.at = function (index: number) {
        index = Math.trunc(index) || 0;
        if (index < 0) index += this.length;
        if (index < 0 || index >= this.length) return undefined;
        return this[index];
    };
}

if (!Array.prototype.includes) {
    Array.prototype.includes = function (searchElement: any, fromIndex?: number) {
        return this.indexOf(searchElement, fromIndex) !== -1;
    };
}

// ---------- STRING ----------
if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function (search: string | RegExp, replacement: string) {
        if (search instanceof RegExp) return this.replace(search, replacement);
        return this.split(search).join(replacement);
    };
}

if (!String.prototype.padStart) {
    String.prototype.padStart = function (targetLength: number, padString: string = ' ') {
        targetLength = targetLength >> 0;
        padString = String(padString);
        if (this.length >= targetLength) return String(this);
        targetLength -= this.length;
        if (targetLength > padString.length) padString += padString.repeat(targetLength / padString.length);
        return padString.slice(0, targetLength) + String(this);
    };
}

if (!String.prototype.padEnd) {
    String.prototype.padEnd = function (targetLength: number, padString: string = ' ') {
        targetLength = targetLength >> 0;
        padString = String(padString);
        if (this.length >= targetLength) return String(this);
        targetLength -= this.length;
        if (targetLength > padString.length) padString += padString.repeat(targetLength / padString.length);
        return String(this) + padString.slice(0, targetLength);
    };
}

// ---------- PROMISE ----------
if (!(Promise as any).allSettled) {
    (Promise as any).allSettled = function (promises: any[]) {
        return Promise.all(
            promises.map(p =>
                Promise.resolve(p).then(
                    value => ({status: 'fulfilled', value}),
                    reason => ({status: 'rejected', reason})
                )
            )
        );
    };
}

if (!(Promise as any).any) {
    (Promise as any).any = function (promises: any[]) {
        return new Promise((resolve, reject) => {
            let rejections: any[] = [];
            let pending = promises.length;
            if (pending === 0) reject(new AggregateError([], 'All promises were rejected'));
            for (const p of promises) {
                Promise.resolve(p)
                    .then(resolve)
                    .catch(err => {
                        rejections.push(err);
                        if (--pending === 0) reject(new AggregateError(rejections, 'All promises were rejected'));
                    });
            }
        });
    };
}

// ---------- MAP / SET ----------
if (typeof Map === 'undefined') {
    (window as any).Map = function () {
        const entries: [any, any][] = [];
        return {
            set(k: any, v: any) {
                entries.push([k, v]);
                return this;
            },
            get(k: any) {
                return entries.find(([key]) => key === k)?.[1];
            },
            has(k: any) {
                return entries.some(([key]) => key === k);
            },
            delete(k: any) {
                const i = entries.findIndex(([key]) => key === k);
                if (i !== -1) entries.splice(i, 1);
            },
            clear() {
                entries.length = 0;
            },
            keys() {
                return entries.map(([k]) => k);
            },
            values() {
                return entries.map(([, v]) => v);
            },
            entries() {
                return entries.slice();
            },
            size: entries.length,
        };
    } as any;
}

if (typeof Set === 'undefined') {
    (window as any).Set = function () {
        const items: any[] = [];
        return {
            add(v: any) {
                if (!items.includes(v)) items.push(v);
                return this;
            },
            has(v: any) {
                return items.includes(v);
            },
            delete(v: any) {
                const i = items.indexOf(v);
                if (i !== -1) items.splice(i, 1);
            },
            clear() {
                items.length = 0;
            },
            values() {
                return items.slice();
            },
            size: items.length,
        };
    } as any;
}

// ---------- GLOBAL ----------
if (!(globalThis as any)) {
    (window as any).globalThis = window;
}

if (!(window as any).queueMicrotask) {
    (window as any).queueMicrotask = (cb: Function) => Promise.resolve().then(cb);
}

// ---------- URL / SEARCH PARAMS ----------
if (typeof URL === 'undefined') {
    (window as any).URL = class {
        href: string;

        constructor(href: string) {
            this.href = href;
        }
    };
}

if (typeof URLSearchParams === 'undefined') {
    (window as any).URLSearchParams = class {
        private params: Record<string, string> = {};

        constructor(queryString: string) {
            queryString.replace(/^\?/, '').split('&').forEach(p => {
                const [k, v] = p.split('=');
                if (k) this.params[decodeURIComponent(k)] = decodeURIComponent(v || '');
            });
        }

        get(key: string) {
            return this.params[key];
        }
    };
}

// ---------- DOM COLLECTION ----------
if (!(NodeList.prototype as any).forEach) {
    (NodeList.prototype as any).forEach = Array.prototype.forEach;
}

// ---------- TRANSLATOR / EXTENSION DOM MUTATION GUARD ----------
// Google Translate and similar tools mutate text nodes outside React. During reconciliation,
// React can hit NotFoundError when parent/child relationships are unexpectedly changed.
if (typeof Node !== "undefined" && !(Node.prototype as any).__genieDomMutationGuardInstalled) {
    const originalInsertBefore = Node.prototype.insertBefore;
    const originalRemoveChild = Node.prototype.removeChild;
    const originalReplaceChild = Node.prototype.replaceChild;

    const isNotFoundError = (error: any) => error?.name === "NotFoundError";

    Node.prototype.insertBefore = function (newNode: Node, referenceNode: Node | null) {
        if (referenceNode && referenceNode.parentNode !== this) {
            return this.appendChild(newNode);
        }
        try {
            return originalInsertBefore.call(this, newNode, referenceNode);
        } catch (error: any) {
            if (isNotFoundError(error)) {
                return this.appendChild(newNode);
            }
            throw error;
        }
    };

    Node.prototype.removeChild = function (child: Node) {
        if (child?.parentNode !== this) {
            return child;
        }
        try {
            return originalRemoveChild.call(this, child);
        } catch (error: any) {
            if (isNotFoundError(error)) {
                return child;
            }
            throw error;
        }
    };

    Node.prototype.replaceChild = function (newChild: Node, oldChild: Node) {
        if (oldChild?.parentNode !== this) {
            if (newChild.parentNode !== this) {
                return this.appendChild(newChild);
            }
            return oldChild;
        }
        try {
            return originalReplaceChild.call(this, newChild, oldChild);
        } catch (error: any) {
            if (isNotFoundError(error)) {
                if (newChild.parentNode !== this) {
                    return this.appendChild(newChild);
                }
                return oldChild;
            }
            throw error;
        }
    };

    Object.defineProperty(Node.prototype, "__genieDomMutationGuardInstalled", {
        value: true,
        configurable: false,
        enumerable: false,
        writable: false,
    });
}
